import { useState, type FormEvent } from 'react'
import { referralsService } from '@/services/referralsService'
import { extractApiError } from '@/utils/extractApiError'

const EMPTY = {
  nome: '',
  empresa: '',
  telefone: '',
  email: '',
  site: '',
  observacao: '',
}

export function useParceirosLeadForm(onCreated: () => Promise<void> | void) {
  const [values, setValues] = useState(EMPTY)
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState('')
  const [ok, setOk] = useState('')

  function patch(field: keyof typeof EMPTY, value: string) {
    setValues((prev) => ({ ...prev, [field]: value }))
  }

  async function submit(event: FormEvent) {
    event.preventDefault()
    setSubmitting(true)
    setError('')
    setOk('')
    try {
      await referralsService.createMine({
        nome: values.nome.trim(),
        empresa: values.empresa.trim(),
        telefone: values.telefone.trim() || undefined,
        email: values.email.trim() || undefined,
        site: values.site.trim() || undefined,
        observacao: values.observacao.trim() || undefined,
      })
      setValues(EMPTY)
      setOk('Lead cadastrado. A equipe comercial já recebe o contato.')
      await onCreated()
    } catch (error) {
      setError(extractApiError(error, 'Não foi possível cadastrar o lead. Tente de novo.').message)
    } finally {
      setSubmitting(false)
    }
  }

  return { values, patch, submitting, error, ok, submit }
}
